let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gZYOx")).then(() => parcelRequire('HiDPk'));